var _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurtainOpen2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_319950584548557786261287286658609347588",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10,
    r: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 10,
    r: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9.25,
    width: 20,
    height: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 26.0093V9.8H12V25.9905C12 25.9905 11.9618 26.379 11.7778 26.5571C11.6434 26.6872 11.5427 26.8 11.3333 26.8C11.1239 26.8 10.8889 26.5571 10.8889 26.5571C10.8889 26.5571 10.8803 26.1524 10.6667 26.1524C10.453 26.1524 10.4444 26.5571 10.4444 26.5571C10.4444 26.5571 10.2094 26.8 10 26.8C9.7906 26.8 9.70873 26.7741 9.55556 26.5571C9.45868 26.4199 9.54701 26.1524 9.33333 26.1524C9.11965 26.1524 9.11111 26.5571 9.11111 26.5571C9.11111 26.5571 8.87607 26.8 8.66667 26.8C8.45726 26.8 8.35639 26.6873 8.22222 26.5571C8.044 26.3843 8 26.0093 8 26.0093Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.67,
    y1: 14.4,
    x2: 10.67,
    y2: 23.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.33,
    y1: 12.4,
    x2: 9.33,
    y2: 21.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.0093V9.8H24V25.9905C24 25.9905 23.9618 26.379 23.7778 26.5571C23.6434 26.6872 23.5427 26.8 23.3333 26.8C23.1239 26.8 22.8889 26.5571 22.8889 26.5571C22.8889 26.5571 22.8803 26.1524 22.6667 26.1524C22.453 26.1524 22.4444 26.5571 22.4444 26.5571C22.4444 26.5571 22.2094 26.8 22 26.8C21.7906 26.8 21.7087 26.7741 21.5556 26.5571C21.4587 26.4199 21.547 26.1524 21.3333 26.1524C21.1197 26.1524 21.1111 26.5571 21.1111 26.5571C21.1111 26.5571 20.8761 26.8 20.6667 26.8C20.4573 26.8 20.3564 26.6873 20.2222 26.5571C20.044 26.3843 20 26.0093 20 26.0093Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.33,
    y1: 14.4,
    x2: 21.33,
    y2: 23.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 4.895 13.105 4 12 4C10.895 4 10 4.895 10 6C10 7.105 10.895 8 12 8C13.105 8 14 7.105 14 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 6C22 4.895 21.105 4 20 4C18.895 4 18 4.895 18 6C18 7.105 18.895 8 20 8C21.105 8 22 7.105 22 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.67,
    y1: 12.4,
    x2: 22.67,
    y2: 21.6,
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_319950584548557786261287286658609347588)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0Z",
    fill: "url(#hinava_random_uuid_282769016747168616023961553909746212039)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_282769016747168616023961553909746212039",
    x1: 16,
    y1: 10.5107,
    x2: 16,
    y2: 29.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtainOpen2);
export default __webpack_public_path__ + "static/media/curtain-open-2.9419c5cb267519f587b5934a3d468e71.svg";
export { ForwardRef as ReactComponent };